<template>
  <div v-if="roleId">
    <default-layout v-if="[1, 4].includes(roleId)"></default-layout>
    <document-layout v-else></document-layout>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'
import DefaultLayout from './DefaultLayout.vue'
import DocumentLayout from './DocumentLayout.vue'
import { initProtocol } from './protocol'
import { initRelatedProtocols } from './related-protocols/relatedProtocols'
import { initAcknowledgment } from '@/components/acknowledgment'
import { initComments } from '@/components/comments/v2'
import { initNotes } from '@/components/notes'
import { ENTITY_TYPE } from '@/utils/constants'

export default {
  name: 'Index',
  components: { DefaultLayout, DocumentLayout },
  setup() {
    const store = useStore()
    const roleId = computed(() => store.state.user.userData?.roleId)
    const { protocolId } = initProtocol()

    initRelatedProtocols(protocolId.value)
    initAcknowledgment({
      entityTypeId: ENTITY_TYPE.PROTOCOL,
      entityId: protocolId.value,
    })
    initComments({
      entityTypeId: ENTITY_TYPE.PROTOCOL,
      entityId: protocolId.value,
    })
    initNotes({
      entityTypeId: ENTITY_TYPE.PROTOCOL,
      entityId: protocolId.value,
    })

    return { roleId }
  },
}
</script>
